import { Component } from '@angular/core';
import 'ag-grid-enterprise';
import { HttpClient } from '@angular/common/http';
import {
  ColDef,
  GridApi,
  GridOptions,
  ValueFormatterParams,
  StateUpdatedEvent,
  IGetRowsParams,
} from 'ag-grid-community';
import { UserGridStateService } from '../../user-grid-state.service';
import { LadingStatusCellEditorComponent } from '../lading-status-cell-editor/lading-status-cell-editor.component';
import { ToastrService } from 'ngx-toastr';



@Component({
  selector: 'app-work-orders-client',
  templateUrl: './work-orders-client.component.html',
  styleUrls: ['./work-orders-client.component.scss']
})
export class WorkOrdersClientComponent {
  private apiUrl = './api/work_orders/work_orders_client.php';
  private userTypeUrl = './api/work_orders/get_user_type.php';
  gridUserType: string = '';
  // Grid options
  gridApi!: GridApi;
  public rowData: any[] = [];
  public theme: string = 'ag-theme-ulaap';
  public gridOptions: GridOptions = {};
  public initialState: any = {};
  public gridReady = false;
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true
  };

  public columnDefs: ColDef[] = [];

  private originalFieldList: { field: string; headerName: string; dataType: string }[] = [
    // UUID fields (will be hidden)
    { field: 'lading_uuid', headerName: 'Lading UUID', dataType: 'uuid' },
    { field: 'shipper_contact_uuid', headerName: 'Shipper Contact UUID', dataType: 'uuid' },
    { field: 'consignee_contact_uuid', headerName: 'Consignee Contact UUID', dataType: 'uuid' },
    { field: 'carrier_contact_uuid', headerName: 'Carrier Contact UUID', dataType: 'uuid' },
    { field: 'customer_contact_uuid', headerName: 'Customer Contact UUID', dataType: 'uuid' },
    { field: 'manifest_uuid', headerName: 'Manifest UUID', dataType: 'uuid' },
    { field: 'driver_contact_uuid', headerName: 'Driver Contact UUID', dataType: 'uuid' },
    { field: 'interline_carrier_uuid', headerName: 'Interline Carrier UUID', dataType: 'uuid' },
    { field: 'user_uuid', headerName: 'User UUID', dataType: 'uuid' },
    { field: 'domain_uuid', headerName: 'Domain UUID', dataType: 'uuid' },
    { field: 'lading_consolidation_uuid', headerName: 'Lading Consolidation UUID', dataType: 'uuid' },
    { field: 'parent_lading_uuid', headerName: 'Parent Lading UUID', dataType: 'uuid' },
    { field: 'lading_consolidation_uuid', headerName: 'Lading Consolidation UUID', dataType: 'uuid' },
    

    // Timestamp fields
    { field: 'carrier_invoice_received', headerName: 'Carrier Invoice Received', dataType: 'timestamp without time zone' },
    { field: 'modified', headerName: 'Modified', dataType: 'timestamp without time zone' },
    { field: 'intake_date', headerName: 'Intake Date', dataType: 'timestamp without time zone' },
    { field: 'appointment_date', headerName: 'Appointment Date', dataType: 'timestamp without time zone' },
    { field: 'appointment_start', headerName: 'Appointment Start', dataType: 'timestamp with time zone' },
    { field: 'appointment_end', headerName: 'Appointment End', dataType: 'timestamp with time zone' },
    { field: 'created', headerName: 'Created', dataType: 'timestamp without time zone' },
    { field: 'fbi_invoice_date', headerName: 'FBI Invoice Date', dataType: 'timestamp without time zone' },
    { field: 'consignee_contact_date', headerName: 'Consignee Contact Date', dataType: 'timestamp without time zone' },
    { field: 'lading_status_updated', headerName: 'Lading Status Updated', dataType: 'timestamp without time zone' },
    { field: 'load_start', headerName: 'Load Start', dataType: 'timestamp without time zone' },
    { field: 'load_end', headerName: 'Load End', dataType: 'timestamp without time zone' },
    { field: 'drop_trailer_status_updated', headerName: 'Drop Trailer Status Updated', dataType: 'timestamp without time zone' },
    { field: 'estimated_load_start', headerName: 'Estimated Load Start', dataType: 'timestamp without time zone' },
    { field: 'carrier_paid_date', headerName: 'Carrier Paid Date', dataType: 'timestamp without time zone' },
    { field: 'estimated_load_end', headerName: 'Estimated Load End', dataType: 'timestamp without time zone' },
    { field: 'actual_delivery', headerName: 'Actual Delivery', dataType: 'timestamp with time zone' },
    { field: 'actual_pickup', headerName: 'Actual Pickup', dataType: 'timestamp with time zone' },
    { field: 'tmp_appointment_start', headerName: 'Temp Appointment Start', dataType: 'timestamp with time zone' },
    { field: 'tmp_appointment_end', headerName: 'Temp Appointment End', dataType: 'timestamp with time zone' },

    // Numeric fields
    { field: 'intake_pieces', headerName: 'Intake Pieces', dataType: 'numeric' },
    { field: 'lading_error', headerName: 'Lading Error', dataType: 'numeric' },

    // Boolean fields
    { field: 'customer_invoice', headerName: 'Customer Invoice', dataType: 'boolean' },
    { field: 'drop_trailer', headerName: 'Drop Trailer', dataType: 'boolean' },
    { field: 'expedited', headerName: 'Expedited', dataType: 'boolean' },
    { field: 'hot', headerName: 'Hot', dataType: 'boolean' },
    { field: 'print_enable', headerName: 'Print Enable', dataType: 'boolean' },
    { field: 'related_ladings', headerName: 'Related Ladings', dataType: 'boolean' },
    { field: 'consolidation_parent', headerName: 'Consolidation Parent', dataType: 'boolean' },

    // Text fields
    { field: 'shipper_name', headerName: 'Shipper Name', dataType: 'text' },
    { field: 'shipper_locality', headerName: 'Shipper City', dataType: 'text' },
    { field: 'shipper_region', headerName: 'Shipper Region', dataType: 'text' },
    { field: 'consignee_name', headerName: 'Consignee Name', dataType: 'text' },
    { field: 'consignee_locality', headerName: 'Consignee City', dataType: 'text' },
    { field: 'consignee_region', headerName: 'Consignee Region', dataType: 'text' },
    { field: 'carrier_name', headerName: 'Carrier Name', dataType: 'text' },
    { field: 'carrier_locality', headerName: 'Carrier City', dataType: 'text' },
    { field: 'carrier_region', headerName: 'Carrier Region', dataType: 'text' },
    { field: 'modified_by', headerName: 'Modified By', dataType: 'text' },
    { field: 'created_by', headerName: 'Created By', dataType: 'text' },
    { field: 'customer_name', headerName: 'Customer Name', dataType: 'text' },
    { field: 'consolidation_id', headerName: 'Consolidation ID', dataType: 'text' },
    

  ];

  private carrierFieldList: { field: string; headerName: string; dataType: string }[] = [
    // UUID fields (will be hidden)
    { field: 'lading_uuid', headerName: 'Lading UUID', dataType: 'uuid' },
    { field: 'shipper_contact_uuid', headerName: 'Shipper Contact UUID', dataType: 'uuid' },
    { field: 'consignee_contact_uuid', headerName: 'Consignee Contact UUID', dataType: 'uuid' },
    { field: 'carrier_contact_uuid', headerName: 'Carrier Contact UUID', dataType: 'uuid' },
    { field: 'customer_contact_uuid', headerName: 'Customer Contact UUID', dataType: 'uuid' },
    { field: 'manifest_uuid', headerName: 'Manifest UUID', dataType: 'uuid' },
    { field: 'driver_contact_uuid', headerName: 'Driver Contact UUID', dataType: 'uuid' },
    { field: 'lading_consolidation_uuid', headerName: 'Lading Consolidation UUID', dataType: 'uuid' },

    // Timestamp fields
    { field: 'carrier_invoice_received', headerName: 'Carrier Invoice Received', dataType: 'timestamp without time zone' },
    { field: 'appointment_date', headerName: 'Appointment Date', dataType: 'timestamp without time zone' },
    { field: 'appointment_start', headerName: 'Appointment Start', dataType: 'timestamp with time zone' },
    { field: 'appointment_end', headerName: 'Appointment End', dataType: 'timestamp with time zone' },
    { field: 'load_start', headerName: 'Load Start', dataType: 'timestamp without time zone' },
    { field: 'load_end', headerName: 'Load End', dataType: 'timestamp without time zone' },


    // Boolean fields
    { field: 'drop_trailer', headerName: 'Drop Trailer', dataType: 'boolean' },
    { field: 'expedited', headerName: 'Expedited', dataType: 'boolean' },
    { field: 'hot', headerName: 'Hot', dataType: 'boolean' },
    { field: 'consolidation_parent', headerName: 'Consolidation Parent', dataType: 'boolean' },


    // Text fields specific to carrier
    { field: 'lading_number', headerName: 'Lading Number', dataType: 'text' },
    { field: 'pro_bill', headerName: 'Pro Bill', dataType: 'text' },
    { field: 'trip_number', headerName: 'Trip Number', dataType: 'text' },
    { field: 'consolidation_id', headerName: 'Consolidation ID', dataType: 'text' },
    { field: 'partial_or_full', headerName: 'Partial or Full', dataType: 'text' },
    { field: 'shipment_number', headerName: 'Shipment Number', dataType: 'text' },
    { field: 'load_pieces', headerName: 'Load Pieces', dataType: 'text' },
    { field: 'load_weight', headerName: 'Load Weight', dataType: 'text' },
    { field: 'load_weight_actual', headerName: 'Actual Load Weight', dataType: 'text' },
    { field: 'load_length', headerName: 'Load Length', dataType: 'text' },
    { field: 'carrier_tractor', headerName: 'Carrier Tractor', dataType: 'text' },
    { field: 'carrier_trailer', headerName: 'Carrier Trailer', dataType: 'text' },
    { field: 'type_of_equipment', headerName: 'Type of Equipment', dataType: 'text' },
    { field: 'equipment_options', headerName: 'Equipment Options', dataType: 'text' },
    { field: 'rate_confirmation', headerName: 'Rate Confirmation', dataType: 'text' },
    { field: 'rated_miles', headerName: 'Rated Miles', dataType: 'text' },
    { field: 'alternate_reference', headerName: 'Alternate Reference', dataType: 'text' },
    { field: 'seal_number', headerName: 'Seal Number', dataType: 'text' },
    { field: 'lading_status', headerName: 'Lading Status', dataType: 'text' },
    { field: 'shipper_name', headerName: 'Shipper Name', dataType: 'text' },
    { field: 'shipper_locality', headerName: 'Shipper City', dataType: 'text' },
    { field: 'shipper_region', headerName: 'Shipper Region', dataType: 'text' },
    { field: 'consignee_name', headerName: 'Consignee Name', dataType: 'text' },
    { field: 'consignee_locality', headerName: 'Consignee City', dataType: 'text' },
    { field: 'consignee_region', headerName: 'Consignee Region', dataType: 'text' },
    { field: 'customer_name', headerName: 'Customer Name', dataType: 'text' },
    { field: 'csa_number', headerName: 'CSA Number', dataType: 'text' },
    { field: 'fast_number', headerName: 'FAST Number', dataType: 'text' },
    { field: 'appointment_contact', headerName: 'Appointment Contact', dataType: 'text' },
    { field: 'carrier_invoice_number', headerName: 'Carrier Invoice Number', dataType: 'text' },
    { field: 'carrier_statement_number', headerName: 'Carrier Statement Number', dataType: 'text' },
    { field: 'product_status', headerName: 'Product Status', dataType: 'text' },
    { field: 'lading_id', headerName: 'Lading ID', dataType: 'text' },
    { field: 'manifest_uuid', headerName: 'Manifest UUID', dataType: 'uuid' },
    { field: 'customer_po', headerName: 'Customer PO', dataType: 'text' },
    { field: 'pickup_reference_number', headerName: 'Pickup Reference Number', dataType: 'text' },
    { field: 'delivery_reference_number', headerName: 'Delivery Reference Number', dataType: 'text' },
    { field: 'booking_number', headerName: 'Booking Number', dataType: 'text' },
    { field: 'release_number', headerName: 'Release Number', dataType: 'text' },
    { field: 'drop_trailer_status', headerName: 'Drop Trailer Status', dataType: 'text' },
    { field: 'drop_trailer_status_note', headerName: 'Drop Trailer Status Note', dataType: 'text' },
    
  ];


  public components: any;

constructor(private http: HttpClient,   private toastr: ToastrService,   private gridStateService: UserGridStateService) {
  this.components = {
    ladingStatusCellEditor: LadingStatusCellEditorComponent
  };
}

  ngOnInit() {
    this.fetchUserTypeAndSetupGrid();
  }

  fetchUserTypeAndSetupGrid() {
    // First, fetch the user type
    this.http.get<{ grid_user_type: string }>(this.userTypeUrl).subscribe(
      response => {
        this.gridUserType = response.grid_user_type;

        // Set columnDefs based on gridUserType
        if (this.gridUserType === 'CARRIER') {
          this.columnDefs = this.createColumnDefs(this.carrierFieldList);
        } else {
          this.columnDefs = this.createColumnDefs(this.originalFieldList);
        }

        // Include master-detail configuration
        this.gridOptions = {
          masterDetail: true,
          detailRowHeight: 400,
          domLayout: 'autoHeight',
          getContextMenuItems: this.getContextMenuItems.bind(this),
          detailCellRendererParams: {
            detailGridOptions: {
              defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true
              },
              columnDefs: [
                { field: 'package_uuid', headerName: 'Package UUID', hide: true },
                { field: 'product_uuid', headerName: 'Product UUID', hide: true },
                { field: 'barcode', headerName: 'Barcode' },
                { field: 'product_code', headerName: 'Product Code' },
                { field: 'product_serial_number', headerName: 'Serial Number' },
                { field: 'product_description', headerName: 'Product Description' },
              ],
            },
            getDetailRowData: (params: any) => {
              // Parse the 'packages' JSON string
              let products: any[] = [];
              if (params.data.packages) {
                const packages = JSON.parse(params.data.packages);
                packages.forEach((pkg: any) => {
                  pkg.products.forEach((product: any) => {
                    products.push({
                      package_uuid: pkg.package_uuid,
                      ...product
                    });
                  });
                });
              }
              params.successCallback(products);
            },
          },
          isRowMaster: (dataItem: any) => {
            // Determine if a row should have a detail section
            if (dataItem && dataItem.packages) {
              const packages = JSON.parse(dataItem.packages);
              return packages.length > 0;
            }
            return false;
          }, 
          rowGroupPanelShow: 'always'
        };

        // Fetch and apply grid state after setting up columnDefs and gridOptions
        this.fetchAndApplyGridState(this.gridUserType);
      },
      error => {
        console.error('Error fetching user type', error);
        // Default to originalFieldList if user type cannot be determined
        this.columnDefs = this.createColumnDefs(this.originalFieldList);
        this.fetchAndApplyGridState(null);
      }
    );
  }

  fetchAndApplyGridState(gridUserType: string | null) {
    this.gridStateService.getUserGridState('work_orders_client').subscribe(
      (state) => {
        if (state) {
          this.initialState = state;
        } else if (gridUserType === 'CARRIER') {
          // Apply the default grid state if the user is a carrier and no saved state exists
          this.initialState = this.getDefaultCarrierGridStateCarrier();
        }
        this.gridReady = true;
      },
      error => {
        console.error('Failed to fetch grid state:', error);
        this.gridReady = true;
      }
    );
  }


  // Define the custom context menu items function
getContextMenuItems(params: any) {
  // Default menu items
  const defaultMenuItems = params.defaultItems;

  // Add custom item
  const customItems = [
    {
      name: 'View/Upload Document',
      action: () => {
        const selectedData = params.node.data;
        const lading_uuid = selectedData.lading_uuid;
        const alternate_reference = selectedData.alternate_reference;
  
        // Fetch the URL from the server
        this.http.get<any>(`/api/work_orders/lading_document_app.php?lading_uuid=${lading_uuid}&alternate_reference=${alternate_reference}`).subscribe(
          (response) => {
            if (response.url) {
              window.open(response.url, '_blank'); // Open the link in a new tab
            } else {
              this.toastr.error('Failed to retrieve document link.');
            }
          },
          (error) => {
            console.error('Error fetching document link', error);
            this.toastr.error('Error retrieving document link.');
          }
        );
      },
      icon: '<i class="fa fa-file-invoice"></i>',
      cssClasses: ['custom-context-menu-item']
    }
  ];

  // Return the modified menu items
  return [...defaultMenuItems, 'separator', ...customItems];
}

  // Default grid state for "CARRIER"
  getDefaultCarrierGridStateCarrier() {
    return {
      work_orders_client: {
        sideBar: {
          visible: true,
          openToolPanel: null,
          toolPanels: []
        },
        columnSizing: {
          columnSizingModel: [
            { colId: "expandCollapse", width: 50 },
            { colId: "alternate_reference", width: 200 },
            { colId: "pro_bill", width: 200 },
            { colId: "consolidation_id", width: 200 },
            { colId: "consolidation_parent", width: 50 },
            { colId: "shipper_name", width: 200 },
            { colId: "shipper_locality", width: 200 },
            { colId: "shipper_region", width: 200 },
            { colId: "consignee_name", width: 200 },
            { colId: "consignee_locality", width: 200 },
            { colId: "consignee_region", width: 200 },
            { colId: "load_start", width: 200 },
            { colId: "load_end", width: 200 },
            { colId: "appointment_start", width: 200 },
            { colId: "appointment_end", width: 200 },
            { colId: "appointment_date", width: 200 },
            { colId: "appointment_contact", width: 200 },
            { colId: "lading_status", width: 200 },
            { colId: "load_pieces", width: 200 },
            { colId: "load_weight", width: 200 },
            { colId: "load_weight_actual", width: 200 },
            { colId: "load_length", width: 200 },
            { colId: "lading_number", width: 200 },
            { colId: "customer_po", width: 200 },
            { colId: "drop_trailer", width: 200 },
            { colId: "expedited", width: 200 },
            { colId: "hot", width: 200 },
            { colId: "partial_or_full", width: 200 },
            { colId: "drop_trailer_status", width: 200 },
            { colId: "drop_trailer_status_note", width: 232 },
            { colId: "shipment_number", width: 200 },
            { colId: "carrier_tractor", width: 200 },
            { colId: "carrier_trailer", width: 200 },
            { colId: "type_of_equipment", width: 200 },
            { colId: "equipment_options", width: 200 },
            { colId: "rate_confirmation", width: 200 },
            { colId: "rated_miles", width: 200 },
            { colId: "seal_number", width: 200 },
            { colId: "carrier_name", width: 200 },
            { colId: "customer_name", width: 200 },
            { colId: "csa_number", width: 200 },
            { colId: "fast_number", width: 200 },
            { colId: "lading_id", width: 200 },
            { colId: "pickup_reference_number", width: 200 },
            { colId: "delivery_reference_number", width: 200 },
            { colId: "booking_number", width: 200 },
            { colId: "release_number", width: 200 },
            { colId: "trip_number", width: 200 },
            { colId: "carrier_invoice_number", width: 200 },
            { colId: "carrier_statement_number", width: 200 },
            { colId: "carrier_invoice_received", width: 200 }
          ]
        },
        columnOrder: {
          orderedColIds: [
            "expandCollapse",
            "alternate_reference",
            "pro_bill",
            "consolidation_id",
            "consolidation_parent",
            "shipper_name",
            "shipper_locality",
            "shipper_region",
            "consignee_name",
            "consignee_locality",
            "consignee_region",
            "load_start",
            "load_end",
            "appointment_start",
            "appointment_end",
            "appointment_date",
            "appointment_contact",
            "lading_status",
            "load_pieces",
            "load_weight",
            "load_weight_actual",
            "load_length",
            "lading_number",
            "customer_po",
            "drop_trailer",
            "expedited",
            "hot",
            "partial_or_full",
            "drop_trailer_status",
            "drop_trailer_status_note",
            "shipment_number",
            "carrier_tractor",
            "carrier_trailer",
            "type_of_equipment",
            "equipment_options",
            "rate_confirmation",
            "rated_miles",
            "seal_number",
            "carrier_name",
            "customer_name",
            "csa_number",
            "fast_number",
            "lading_id",
            "pickup_reference_number",
            "delivery_reference_number",
            "booking_number",
            "release_number",
            "trip_number",
            "carrier_invoice_number",
            "carrier_statement_number",
            "carrier_invoice_received"
          ]
        },
        //pagination: { page: 0, pageSize: 100 },
        scroll: { top: 0, left: 0 },
        columnPinning: {
          leftColIds: ["expandCollapse"],
          rightColIds: []
        },
        focusedCell: {
          colId: "alternate_reference",
          rowIndex: 1,
          rowPinned: null
        }
      }
    };
  }

  resetToDefaultState() {
    if (this.gridUserType === 'CARRIER') {
      const defaultState = this.getDefaultCarrierGridStateCarrier();
      this.initialState = defaultState;
      this.applyGridState(defaultState);
    } else {
      console.log('Reset functionality for other user types will be implemented later.');
    }
  }

  groupByConsolidationId(): void {
    if (this.gridApi) {
      this.gridApi.applyColumnState({
        state: [
          {
            colId: 'consolidation_id',
            rowGroup: true
          }
        ],
        applyOrder: true
      });
      this.gridApi.onGroupExpandedOrCollapsed(); 
    }
  }


  applyGridState(state: any) {
    if (this.gridApi) {
      // Apply column state including order
      this.gridApi.applyColumnState({
        state: state.work_orders_client.columnSizing.columnSizingModel,
        applyOrder: true
      });
  
      // Apply other grid state settings
      //this.gridApi.paginationSetPageSize(state.work_orders_client.pagination.pageSize);
      this.gridApi.ensureIndexVisible(state.work_orders_client.scroll.top);
      this.gridApi.ensureColumnVisible(state.work_orders_client.scroll.left);
      this.gridApi.setFilterModel(state.work_orders_client.filterModel || {});
    }
  }

  onGridReady(params: any) {
    this.gridApi = params.api;

    // Apply the initial state
    if (this.initialState && this.gridApi) {
      this.gridApi.setFilterModel(this.initialState.filterModel);
      this.gridApi.applyColumnState({
        state: this.initialState.columnState,
        applyOrder: true
      });
    }

    this.fetchData();
  }

  fetchData() {
    this.gridApi.showLoadingOverlay(); // Show loading overlay
  
    this.http.get<any>(this.apiUrl).subscribe(
      response => {
        this.rowData = response.data.map((item: any) => ({
          ...item,
          packages: item.packages ? item.packages : '[]'
        }));
        this.gridApi.hideOverlay(); // Hide overlay when data is ready
      },
      error => {
        console.error('Error fetching data', error);
        this.gridApi.hideOverlay(); // Hide overlay if an error occurs
      }
    );
  }

  onStateUpdated(params: StateUpdatedEvent<any>): void {
    if (params.sources.indexOf('columnSizing') > -1 || params.sources.indexOf('columnOrder') > -1) {
      this.gridStateService.saveUserGridState('work_orders_client', params.state);
    }
  }

  createColumnDefs(fieldList: { field: string; headerName: string; dataType: string }[]): ColDef[] {
    const columnDefs: ColDef[] = [];

    // Include the master-detail expand/collapse column
    columnDefs.push({
      headerName: '',
      colId: "expandCollapse", 
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        suppressCount: true,
        innerRenderer: () => null
      },
      width: 50,
      suppressSizeToFit: true,
      menuTabs: [],
      sortable: false,
      filter: false,
      pinned: 'left'
    });

    for (const fieldInfo of fieldList) {
      const { field, headerName, dataType } = fieldInfo;

      if (this.isUuidField(field)) {
        continue; // Skip UUID fields
      }

      const colDef: ColDef = {
        headerName: headerName,
        field: field,
        hide: false,
        sortable: true,
        filter: true,
        valueFormatter: this.getValueFormatter(dataType),
        enableRowGroup: ['consolidation_id'].includes(field)
      };

      if (field === 'lading_status') {
        colDef.editable = true;
        colDef.cellEditor = 'ladingStatusCellEditor';
      } else if (field === 'pro_bill') {
        colDef.editable = true; // Enable editing for pro_bill
      }

      columnDefs.push(colDef);
    }

    return columnDefs;
  }

  isUuidField(field: string): boolean {
    // List of UUID fields to hide
    const uuidFields = [
      'lading_uuid',
      'shipper_contact_uuid',
      'consignee_contact_uuid',
      'carrier_contact_uuid',
      'customer_contact_uuid',
      'manifest_uuid',
      'driver_contact_uuid',
      'interline_carrier_uuid',
      'user_uuid',
      'domain_uuid',
      'lading_consolidation_uuid',
      'parent_lading_uuid'
    ];
    return uuidFields.includes(field);
  }

  getValueFormatter(dataType: string): any {
    if (dataType.includes('timestamp')) {
      return (params: ValueFormatterParams) => {
        return params.value ? new Date(params.value).toLocaleString() : '';
      };
    }

    if (dataType === 'boolean') {
      return (params: ValueFormatterParams) => {
        return params.value ? 'Yes' : 'No';
      };
    }

    // For numeric fields, format as numbers
    if (dataType === 'numeric') {
      return (params: ValueFormatterParams) => {
        return params.value != null ? Number(params.value).toLocaleString() : '';
      };
    }

    // For other data types, no formatter is needed
    return null;
  }

  exportToCSV() {
    const params = { columnSeparator: '|' };
    this.gridApi.exportDataAsCsv(params);
  }

  exportToExcel() {
    this.gridApi.exportDataAsExcel();
  }

  toggleTheme() {
    this.theme = this.theme === 'ag-theme-ulaap' ? 'ag-theme-ulaap-dark' : 'ag-theme-ulaap';
  }

  onCellValueChanged(event: any) {
    if (event.colDef.field === 'lading_status') {
      const newStatus = event.newValue;
      const lading_uuid = event.data.lading_uuid;
      const dateNeededStatuses = [
        'Arrived Shipper', 'Loading Shipper', 'Loaded Shipper',
        'En Route Consignee', 'Arrived Consignee', 'Unloading Consignee',
        'Delivered Consignee'
      ];
  
      let postData: any = {
        lading_uuid: lading_uuid,
        lading_status: newStatus
      };
  
      if (dateNeededStatuses.includes(newStatus)) {
        // Get cell editor instance
        const cellEditorInstances = event.api.getCellEditorInstances({ rowNodes: [event.node], columns: [event.column] });
        if (cellEditorInstances.length > 0) {
          const cellEditor = cellEditorInstances[0] as any;
          const date = cellEditor.ladingStatusForm.get('date').value;
          const time = cellEditor.ladingStatusForm.get('time').value;
          const timezone = cellEditor.ladingStatusForm.get('timezone').value;
  
          // Format date and time
          postData.selected_date = this.formatDateForApi(date);
          postData.selected_time = this.convertTo24Hr(time);
          postData.selected_timezone = timezone;
        }
      }
  
      // Send the update to the server
      this.http.post<any>('/api/lading_status/add_lading_status.php', postData).subscribe(
        (response) => {
          console.log('Lading status updated.', response);
          this.toastr.success('Lading status updated successfully.');

        },
        (error) => {
          console.error('Lading status not updated:', error);
          this.toastr.error('Failed to update lading status.');

        }
      );
    }else if (event.colDef.field === 'pro_bill') {
      const newProBill = event.newValue;
      const lading_uuid = event.data.lading_uuid;
    
      let postData = {
        uuid: lading_uuid,
        column_name: 'pro_bill',
        column_value: newProBill
      };
    
      // Send the update to the server
      this.http.post<any>('/api/work_orders/update_lading.php', postData).subscribe(
        (response) => {
          console.log('Pro Bill updated.', response);
          this.toastr.success('Pro Bill updated successfully.');
        },
        (error) => {
          console.error('Pro Bill not updated:', error);
          this.toastr.error('Failed to update Pro Bill.');
        }
      );
    }

  }

// Converts a Date to string in mm/dd/yyyy format
formatDateForApi(date: Date): string {
  const day = date.getDate();
  const month = date.getMonth() + 1; // Month is 0-based
  const year = date.getFullYear();
  return `${this.padZero(month)}/${this.padZero(day)}/${year}`;
}

// Converts time string to 24-hour format (assuming input like '3:45 PM')
convertTo24Hr(timeString: string): string {
  const time = timeString.toUpperCase();
  const [timePart, period] = time.split(' ');
  let [hours, minutes] = timePart.split(':').map(Number);

  if (period === 'PM' && hours < 12) {
    hours += 12;
  } else if (period === 'AM' && hours === 12) {
    hours = 0;
  }

  return `${this.padZero(hours)}:${this.padZero(minutes)}`;
}

// Pads single-digit numbers with a leading zero
padZero(num: number): string {
  return num < 10 ? '0' + num : num.toString();
}

}